import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import ROLES from '../../constants/Roles';

import AutoComplete from '../Common/AutoComplete';
import { Card, CardHeader } from 'material-ui/Card';
import ContactListItem from '../Contact/ContactListItem';
import DepartmentListItem from '../Department/DepartmentListItem';
import DetailView from '../Common/DetailView';
import Dialog from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import { Form as Formsy } from 'formsy-react';
import { List } from 'material-ui/List';
import LinearProgress from 'material-ui/LinearProgress';
import MenuItem from 'material-ui/MenuItem';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import TextField from '../Common/TextField';

import DefaultIcon from 'material-ui/svg-icons/navigation/check';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import PersonAddIcon from 'material-ui/svg-icons/social/person-add';
import GroupAddIcon from 'material-ui/svg-icons/social/group-add';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import OrganisationIcon from 'material-ui/svg-icons/social/domain';

import OrganisationActions from '../../actions/OrganisationActionCreator';
import OrganisationStore from '../../stores/OrganisationStore';
import OrganisationContactStore from '../../stores/OrganisationContactStore';
import DepartmentActions from '../../actions/DepartmentActionCreator';
import DepartmentStore from '../../stores/DepartmentStore';
import ContactActions from '../../actions/ContactActionCreator';
import ContactStore from '../../stores/ContactStore';
import AppActions from '../../actions/AppActionCreator';

import { statusColours } from '../../constants/ColourConstants';

import buildContextMenu from '../Common/BuildContextMenu';
import Subheader from 'material-ui/Subheader';

let timeout;

const style = {
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const Organisation = React.createClass({

    getInitialState: function () {

        return {
            details: {
                name: '',
                description: '',
                isDefault: null
            },
            contacts: [],
            contactList: [],
            actions: [],
            departments: [],
            departmentList: [],
            links: {
                back: '/dashboard/organisations',
                edit: ''
            },

            dialog: {
                open: false,
                value: null,
                data: null
            },
        }
    },

    getMenuItems: function(data) {
        const contactDialog = function() { this._openDialog('contact'); }.bind(this);
        const departmentDialog = function() { this._openDialog('department'); }.bind(this);
        return [
            {
                link: '/dashboard/user/new',
                icon: <PersonAddIcon />,
                label: 'Add user',
                key: 'user',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                icon: <GroupAddIcon />,
                label: 'Add department',
                action: departmentDialog,
                key: 'department',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                icon: <PersonAddIcon />,
                label: 'Add contact',
                action: contactDialog,
                key: 'contact',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'divider'
            },
            {
                link: `/dashboard/organisation/${data.id}/settings`,
                icon: <SettingsIcon />,
                label: 'Settings',
                condition: {
                    show: this.context.auth.isRoot(),
                    roles: [ROLES.ADMIN]
                }
            },
            {
                link: '/dashboard/organisation/' + data.id + '/edit',
                icon: <EditIcon />,
                label: 'Edit',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: data.id,
                title: 'Delete ',
                deleteAction: this._onDelete,
                message: (<span>Are you sure you want to delete organisation '{data.name}'?</span>),
                condition: {
                    show:  (!!data.name && !data.isDefault),
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },

    componentDidMount: function() {
        OrganisationStore.addChangeListener(this._onOrganisationChange);
        OrganisationActions.getById(this.props.routeParams.id);

        OrganisationContactStore.addChangeListener(this._onOrganisationContactChange);
        OrganisationActions.getContacts(this.props.routeParams.id);

        ContactStore.addChangeListener(this._onContactChange);

        DepartmentStore.addChangeListener(this._onDepartmentChange);
        OrganisationActions.getDepartments(this.props.routeParams.id);
        this.setState(assign(this.state, {actions: buildContextMenu(this.getMenuItems({id: this.props.routeParams.id}), this.context.auth)}));
    },

    componentWillUnmount: function() {
        DepartmentStore.removeChangeListener(this._onDepartmentChange);
        ContactStore.removeChangeListener(this._onContactChange);
        OrganisationContactStore.removeChangeListener(this._onOrganisationContactChange);
        OrganisationStore.removeChangeListener(this._onOrganisationChange);
    },

    render: function () {

        let dialog;
        let dialogProps;

        switch (this.state.dialog.open) {

            case 'contact':

                 dialogProps = {
                    title: "Add Contact",
                    open: true,
                    modal: false,
                    onRequestClose: this._closeDialog,
                    actions: [
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this._closeDialog} />,
                        <FlatButton key="submit" label="Submit" onTouchTap={this._dialogSave} disabled={this.state.dialog.value === null} />,
                    ]
                };
                dialog = (
                    <Dialog {...dialogProps} >
                        <AutoComplete
                            floatingLabelText="Contact"
                            maxSearchResults={5}
                            dataSource={this.state.contactList}
                            onUpdateInput={this._onContactAutocomplete}
                        />
                    </Dialog>
                );

                break;
            case 'department':
                dialogProps = {
                    title: "Add new department",
                    open: true,
                    modal: false,
                    onRequestClose: this._closeDialog
                };
                dialog = (
                    <Dialog {...dialogProps} >
                        <Formsy onSubmit={this._dialogSave}>
                            <TextField
                                name="name"
                                validations="minLength:2,maxLength:40"
                                validationError="Please use only numbers and letters; at least 2, no more than 40"
                                hintText="Name"
                                floatingLabelText="Name"
                                required
                            />
                            <TextField
                                name="description"
                                validations="maxLength:120"
                                validationError="Please use only numbers and letters"
                                hintText="Description"
                                floatingLabelText="Description"
                            />
                            <FlatButton key="cancel" label="Cancel" onTouchTap={this._closeDialog} />
                            <FlatButton key="submit" label="Add" type="submit" />
                        </Formsy>
                    </Dialog>
                );
                break;

            default: break;
        }


        const detailViewProps = {
            title: (this.state.details.name || 'Organisation'),
            backButton: true,
            backTo: this.state.links.back,
            actions: this.state.actions
        };

        let contactList;

        if (this.state.contacts.length > 0) {
            contactList = (
                <List>
                    <Subheader>Contacts</Subheader>
                    <Divider />
                    {this.state.contacts.map(function(contact) {
                        const loading = (!!contact.loading ? <LinearProgress /> : null);
                        return (
                            <div key={contact.id}>
                                <ContactListItem data={contact} actions={this._getContactActions(contact)} />
                                {loading}
                                <Divider />
                            </div>
                        );
                    }, this)}
                </List>
            );
        }

        return(
            <DetailView {...detailViewProps} >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={this.state.details.name}
                            subtitle={this.state.details.description}
                            avatar={(<OrganisationIcon style={style.icon} color={this.state.details.enabled ? statusColours.primary : statusColours.disabled}/>)}
                        />
                        {contactList}
                    </Card>
                    <Card className="cent-card">
                        <CardHeader
                            title="Departments"
                        />
                        <List style={style.list}>
                        {this.state.departmentList}
                        </List>
                    </Card>
                </div>
                {dialog}
                <ErrorSnackbar/>
            </DetailView>
      );
    },

    _onOrganisationChange: function() {
        const details = OrganisationStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            let state = assign(this.state, {
                details: details,
                actions: buildContextMenu(this.getMenuItems(details), this.context.auth)
            });
            this.setState(state);
        }
    },

    _onDepartmentChange: function() {
        const departments = DepartmentStore.getByOrganisation(this.props.routeParams.id);
        if (departments !== undefined) {
            let departmentList = departments.map(function(department) {
                return (
                    <div key={department.id}>
                        <DepartmentListItem data={department} actions={this._getDepartmentActions(department)}/>
                        <Divider />
                    </div>
                );
            }, this);
            this.setState({departmentList, departments});
        }
    },

    _onOrganisationContactChange: function() {
        const contacts = OrganisationContactStore.getByOrganisation(this.props.routeParams.id);
        if (contacts !== undefined) {

            const state = assign(this.state, {contacts: contacts});
            this.setState(state);
        }
    },

    _onContactAutocomplete: function(input) {
        clearTimeout(timeout);
        if (input !== undefined && input.length >= 2) {
            timeout = setTimeout(function() { ContactActions.search(input, {limit: 10}); }, 500);
        }
    },

    _onContactChange: function() {
        const contacts = ContactStore.getAll(); // get by search
        if (contacts !== undefined) {
            const contactList = contacts.map(function(contact) {
                const click = this._onDialogSelect.bind(this, contact);
                return {
                    text: contact.name,
                    value: <MenuItem key={contact.id} value={contact.id} primaryText={contact.name} onTouchTap={click} />
                };
            }, this);
            const state = assign(this.state, {contactList: contactList});
            this.setState(state);
        }
    },

    _getContactActions: function(contact) {
        const infoLink = '/dashboard/contact/' + contact.id;
        const editLink = '/dashboard/contact/' + contact.id + '/edit';

        return [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            {
                type:'divider'
            },
            {
                link: editLink,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: contact.id,
                menuTitle: 'Remove',
                title: 'Remove Contact',
                deleteAction: this._removeContact,
                message: <span>Are you sure to remove the contact "{contact.name}" ?</span>,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },

    _addContact: function(contact) {
        const index = this.state.contacts.findIndex(function(e) { return e !== undefined && e.id == contact.id; });
        if (0 > index) {
            contact.loading = true;
            var contacts = this.state.contacts;
            contacts.push(contact);
            this.setState(assign(this.state, {contacts: contacts}));
            OrganisationActions.addContact(this.props.routeParams.id, contact.id);
            return true;
        }
        return false;
    },

    _removeContact: function(contactId) {
        const index = this.state.contacts.findIndex(function(e) { return e !== undefined && e.id == contactId; });
        if (0 <= index) {
            let state = this.state;
            state.contacts[index].loading = true;
            this.setState(state);
            OrganisationActions.removeContact(this.props.routeParams.id, contactId);
        }
    },

    _onDelete: function(entityId) {
        if (entityId == this.props.routeParams.id) {
            OrganisationActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    },

    _getDepartmentActions: function(row) {
        const infoLink = '/dashboard/department/' + row.id;
        return [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            { type: 'divider' },
            {
                action: this._setDefault(row.id),
                label: 'Set default',
                icon: <DefaultIcon />,
                condition: {
                    show: (!row.isDefault),
                    roles: [ROLES.ADMIN]
                }
            },
            {
                link: `/dashboard/department/${row.id}/edit`,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete department',
                deleteAction: DepartmentActions.delete,
                message: (
                    <span>
                        Are you sure to delete the department  "{row.name}" ?
                    </span>
                ),
                condition: {
                    show:  row.sysStatus > 4,
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },

    _setDefault: function(entityId) {
        const setDefault = DepartmentActions.setDefault;
        return function() { setDefault(entityId); };
    },

    _openDialog: function(open, value = null, data = null) {
        this.setState({dialog: { open, value, data }});
    },

    _onDialogSelect: function(element) {
        const state = this.state;
        state.dialog.value = element;
        this.setState(state);
    },

    _closeDialog: function() {
        const state = this.state;
        state.dialog.open = false;
        this.setState(this.state);
    },

    _dialogSave: function(model) {
        let close = true;
        switch (this.state.dialog.open) {
            case 'contact':
                close = this._addContact(this.state.dialog.value);
                break;
            case 'department':
                const existingDepartment = this.state.departments.find((d) => (d !== undefined && d.name === model.name));
                if (!!existingDepartment) {
                    AppActions.emitError("A department with this name already exists");
                } else {
                    const newDepartment = {
                        name: model.name,
                        description: model.description,
                        organisationId: this.props.routeParams.id
                    };
                    DepartmentActions.save(newDepartment);
                }
                break;
            default:
                console.error('unhandled dialog');
                close = false;
        }

        if (close) this._closeDialog();
    },

});

Organisation.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Organisation;
